export const isActiveStyles =
  " text-lg text-headingColor font-semibold hover:text-headingColor duration-100 transition-all ease-in-out";

export const isNotActiveStyles =
  " text-lg text-textColor hover:text-headingColor duration-100 transition-all ease-in-out";

export const isIconActiveStyles =
  " text-4xl text-red-600 font-semibold hover:text-headingColor duration-100 transition-all ease-in-out";

export const isNotIconActiveStyles =
  " text-2xl text-slate-400 hover:text-headingColor duration-100 transition-all ease-in-out";
